var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Header__detail Header__init"
  }, [_c('div', {
    staticClass: "left-btn-group"
  }, [!_vm.removeClose ? _c('button', {
    on: {
      "click": _vm.closeAll
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/header-close.svg"),
      "alt": "close"
    }
  })]) : _vm._e(), !_vm.disabled ? _c('button', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/arrow-back.svg"),
      "alt": "back"
    }
  })]) : _vm._e()]), _c('h5', [_vm._v(_vm._s(_vm.tt(_vm.title)))]), !_vm.removeClose ? _c('div', {
    staticClass: "right-btn-group"
  }, [_c('button', {
    staticClass: "Btn__init",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": _vm.initFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.tt(_vm.initText)) + " ")])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }